import { Component, effect, inject, model, OnDestroy, OnInit, output } from '@angular/core';
import { ICurrency } from '@shared/models/currency.model';
import { CurrencyService } from '@shared/services/currency.service';
import { SessionStorageService } from '@shared/services/session-storage.service';

@Component({
  selector: 'app-currency-menu-selector',
  imports: [],
  templateUrl: './currency-menu-selector.component.html',
  styleUrl: './currency-menu-selector.component.scss',
})
export class CurrencyMenuSelectorComponent implements OnDestroy {
  private _currencyService = inject(CurrencyService);
  newSelect = output<ICurrency>();
  selectedCurrency = model<ICurrency | null>();
  backToMenu = output<boolean>();
  private _sessionStorageService = inject(SessionStorageService);
  currencyList: ICurrency[] = [];

  userConfigSign = effect(() => {
    if (this._sessionStorageService.userConfigChanged()) {
      let currency = this._sessionStorageService.config.currency;

      if (currency) this.selectedCurrency.set(currency);
    }
  });

  currencyListSignal = effect(() => {
    this.currencyList = this._currencyService.currencyListSig();
    this.checkCurrencyList();
  });

  ngOnDestroy(): void {
    this.userConfigSign && this.userConfigSign.destroy();
    this.currencyListSignal && this.currencyListSignal.destroy();
  }

  backToMenuClick() {
    this.backToMenu.emit(true);
  }

  changeCurrency(currency: ICurrency) {
    this.newSelect.emit(currency);
    this.selectedCurrency.set(currency);
    this.backToMenu.emit(true);
  }

  private checkCurrencyList() {
    let currency = this._sessionStorageService.config.currency;
    if (currency) {
      this.selectedCurrency.set(currency);
    }
  }
}
